// removed by extract-text-webpack-plugin
module.exports = {"jumbo":"src-components-food----Header-module---jumbo---zLp0F","content":"src-components-food----Header-module---content---1eH_r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/food/Header.module.css
// module id = 402
// module chunks = 32548347793320